<template>
  <div id="schedule_hotspots">
    <div class="teamInfor_main">
      <span
        class="teamItem"
        v-for="(item, itemIndex) in teamInfors"
        :key="itemIndex"
      >
        <span class="teamLogo">
          <img v-if="item && item.teamLogo" :src="item.teamLogo" />
        </span>
        <span
          class="teamName"
          v-text="_valPerFormatHandler(item && item.teamName)"
        ></span>
      </span>
      <span class="section_main">
        <SelectItem
          v-for="selectItem in selectList"
          :key="selectItem.state"
          :options="selectItem"
          :curVal="selectItem.curVal"
          themeClass="whiteBg height40"
          @changeValEvent="selectChangeVal"
        ></SelectItem>
      </span>
    </div>
    <div class="dataArea" v-if="dynamicOptsArr">
      <HTML_SHOOT_HOTSPOT
        v-for="(group, groupIndex) in themeList_data"
        :key="groupIndex"
        :currThemeObj="currThemeObj"
        :datas="group"
        :isShowTip="groupIndex === 0"
        :baseOpts="baseOpts"
        :dynamicOpts="dynamicOptsArr[groupIndex]"
      >
        <template v-slot:selectItem>
          <SelectItem
            :key="svgSelectList[groupIndex].state"
            :options="svgSelectList[groupIndex]"
            :curVal="svgSelectList[groupIndex].curVal"
            themeClass="whiteBg"
            @changeValEvent="selectChangeVal"
          ></SelectItem>
        </template>
        <template v-slot:publishBtn v-if="themeList && themeList.length > 0">
          <span class="publishBtn" @click="clickPublish(groupIndex)">
            <svg
              t="1692698307306"
              class="publishBtn_icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9670"
              width="68%"
              height="68%"
            >
              <path
                d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                p-id="9671"
              ></path>
            </svg>
          </span>
        </template>
      </HTML_SHOOT_HOTSPOT>
      <!-- <span
        class="hotItem"
        v-for="(group, groupIndex) in themeList"
        :key="groupIndex"
      >
        <span class="svgList_area">
          <span class="svgArea_header">
            <span class="svgArea_header_select">
              <SelectItem
                :key="svgSelectList[groupIndex].state"
                :options="svgSelectList[groupIndex]"
                :curVal="svgSelectList[groupIndex].curVal"
                themeClass="whiteBg"
                @changeValEvent="selectChangeVal"
              ></SelectItem>
            </span>
            <span class="svgArea_header_public">
              <span class="publishBtn" @click="clickPublicTheme(themeItem)">
                <svg
                  t="1692698307306"
                  class="publishBtn_icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9670"
                  width="68%"
                  height="68%"
                >
                  <path
                    d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                    p-id="9671"
                  ></path>
                </svg>
              </span>
            </span>
          </span>
          <template v-if="group">
            <span
              class="svgDataRow"
              v-for="item in group.svgDataList"
              :key="item.key"
            >
              <span class="svgDataRow_svg">
                <cup_svgSingleCircle
                  v-if="cy"
                  :currThemeObj="currThemeObj"
                  teamMode="home"
                  :cx="cx"
                  :cy="cy"
                  :strokeWidth="strokeWidth"
                  :svgData="item"
                  :keyArr="cup_svgSingleCircle_keyArr"
                  :svgCenterInforArr="['val', 'name']"
                ></cup_svgSingleCircle>
              </span>
              <span class="svgDataRow_data">
                <span
                  class="svgData_annotate_row"
                  v-for="(name, rowIndex) in item.nameArr"
                  :key="rowIndex"
                >
                  <span class="svgData_annotate_row_clo1" v-text="name"></span>
                  <span
                    class="svgData_annotate_row_clo2"
                    v-text="item.valArr[rowIndex]"
                  ></span>
                </span>
              </span>
            </span>
          </template>
        </span>
        <span class="hotArea" :class="groupIndex == 1 ? 'notTip' : ''">
          <HalfFeildShootHotspot
            v-if="group"
            :datas="group.hotSpotList"
            :iconArr="hotSpot_iconArr"
          ></HalfFeildShootHotspot>
          <span class="themeTips">
            <span
              class="themeTipsItem"
              v-for="(icon, iconIndex) in hotSpot_iconArr"
              :key="iconIndex"
            >
              <span class="themeTipsItem_icon">
                <img :src="icon.split('image://')[1]" />
              </span>
              <span
                class="themeTipsItem_text"
                v-text="iconTipArr[iconIndex]"
              ></span>
            </span>
          </span>
        </span>
      </span> -->
    </div>
  </div>
</template>
<script>
import {
  https_teamDetail_hotspotsSelectList,
  https_teamDetail_hotspotsData,
} from '@api/platfrom_basketball_api'

import SelectItem from '@components/platfromBase/basketball/selectItem.vue'
// import cup_svgSingleCircle from '@components/platfromBase/football/cup_svgSingleCircle.vue'
// import HalfFeildShootHotspot from '@components/basketball/echarts/scatter/halfFeild_shootHotspot.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import platfrom_refresh_data_mixin from '@mixins/platfrom_refresh_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
import HTML_SHOOT_HOTSPOT from '@components/basketball/html/HTML_SHOOT_HOTSPOT/index.vue'

export default {
  name: 'schedule_hotspots',
  components: { SelectItem, HTML_SHOOT_HOTSPOT },
  mixins: [
    cup_base_data_mixin,
    platfrom_refresh_data_mixin,
    single_findAnalysisItem_data_mixin,
  ],
  props: {
    matchInfor: {
      type: Object,
      default: () => ({
        leagueName: '',
        gameDateWeb: '',
        matchStatus: '',
        homeWinLoss: '',
        awayWinLoss: '',
        homeId: '',
        homeTeam: '',
        homeTeamPoints: '-',
        homeTeamLogo: '',
        awayId: '',
        awayTeam: '',
        awayTeamPoints: '-',
        awayTeamLogo: '',
      }),
    },
  },
  data() {
    return {
      themeTemplateType: 25,
      selectList: [
        {
          list: [],
          keyValArr: ['value', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 12.5,
          curVal: '',
          state: 'sectionType',
        },
      ],
      curSelect_sectionType: '',
      svgSelectList: [
        {
          list: [],
          keyValArr: ['value', 'name'],
          placeholder: '请选择',
          isFilterable: true,
          widthVw: 13.5,
          curVal: '',
          state: 'homePlayer',
        },
        {
          list: [],
          keyValArr: ['value', 'name'],
          placeholder: '请选择',
          isFilterable: true,
          widthVw: 13.5,
          curVal: '',
          state: 'awayPlayer',
        },
      ],
      curSelect_homePlayer: '',
      curSelect_awayPlayer: '',
      isRefreshFlag: false,
      teamInfors: [],
      dynamicOptsArr: null,
      baseOpts: {
        // 初始化时就设置好的，不会变
        svgKeyArr: ['name', 'val'], // 数据中需要的映射的字段名['name', 'val']
        svgCenterInforArr: ['val', 'name'], // 中间显示的内容；['name', 'val']
        strokeWidthVw: 0.278, //描边宽度
        cxVw: 3.6, //圆点 x坐标
        cyVw: 3.6, //圆点 y坐标
        echartsIconTipArr: ['投篮命中', '投篮未命中'],
        // echartsHotSpotIconArr: [
        //   'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAa5JREFUSEu9lj1LJEEQhp9qBUX8iJXdVVBE7n7AGR+XiKCYm4gfiSIYiZuIyewZHYgmp4eJuSioiRjrD7hDRcEvNNYVUXC7ZAbG093eZUXbCqeK96muqq4eoYS1zWriQelVpRtoRWmKwoVL4FiEjSph7WhSLorJiMuRnNUmscxYGECpKJUEQs7AshqmzyclBL+yAkAy0B4VVlDqSgoXKmVF6T9Py/pL1ytAKtBxC78A8ybx/8HWwMRZWubiT8+AKHNYfYd4rGkF+uKTRICw5mrZf3NZinc2K4aOsCcRIJXRRasMOeMFRVmqhD81DfwNY+6u+foIgwhDKM5BMcLS2ZQMSziK95YT17QIXBmh/3RKdlzw5ox+t8qKQmOBX8hVG1ok+VNH1TLvCNAK+FFMPI4PITnYdp1EDGOSyOgmSpcjw8WLtIyUM02JQH8Dw44kt0LAAUp7vrMSOk/SslcOoCXQb4+w6wAcSiLQLFCb76xvoO7fqNyWA/iyoLU314Q6+Xb7CQDvJfLdZO9j6v2ieV8Vn7LsIojPdR3fDq8PTgzx+mQ+Q3w++i+XyUf8tjwBnuwGpPR363YAAAAASUVORK5CYII=',
        //   'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAjFJREFUSEu9lj9oE3EUx7/fi71aSLvpUJJTTBBJxSmhg4t0EKRFcXeRti6K2FVBo6BrRZxsi4u7KK2CoLg4lGYSE1RyRS/FwW5NoDY1vye/Sy+5y52Bgudvu9/7vfd57/t+f47oMzay46nmTuuCCCcBZAQyqpcT/AHAJmXFHEy8SFVXN/4WhlEGJ316tMnmXSpcFkiiXxIEW2LgqSnmHav2QYMDIwRYT+fPK+EzQIb7BQ7bWDcol47VSi/9tgCgahWuU8m8AMb+grdXE1BicC7rrD3y/DsAnbkInoeCk2VSFg8g8WYoOeRox+3GtvUbrbMinIHIWE/GisRFrxIX4Gouzc89sggEDzKzU7dZLKqoiqRYNOyF5XsgbrYL6ORdN2me0D1xJ6tWYQFKZnxBZM9hE8REtlb6FAWopvMnIXgH4BAAz6e91OBi1lmbpd6KO7/Ut8BuEdwHcWXPMRLSE3wTgicgbnW1Z2vwoHGU6+n8VSV43K2O5cz05Cl7aTnnyy4ACQUnJjLTUxV7aeWjvycGcY12qvBKIOc6ZANzGaf00JUuKIELcdd1ZQmAbSt/QxTmfVW81oAvAjnuTQ4YibEjzmrF+w5B2gateUi679Z4ble1yj7AV1ZT+TqApDc5MpIcPlx53/A3tQeiTZF9+Zk7k9zaauh43mjED4hdov02mTJAwe7bqD5ENjn2bRr7QYv9qvgvl52GxHpdd05tnA+OB4n1yfQgsT76/jvoX/y2/AEx4rQmIjAhTQAAAABJRU5ErkJggg==',
        // ],
      },
      themeList_data: null,
    }
  },
  created() {
    this.query = this.$route.query
    let baseOpts = JSON.parse(JSON.stringify(this.baseOpts))
    baseOpts.echartsHotSpotIconArr =
      this.currThemeObj.image.echartsHotSpotIconArr
    this.baseOpts = baseOpts
    this.init()
  },
  mounted() {},
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.makeAnalysisItemParams(this.themeTemplateType)
      await this.getSelectList()
      await this.getHotSpotData()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      console.debug('makeAnalysisItemParams')
      this.findAnalysisItemParams = {
        sportType: 'basketball',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
      // let { num } = this.paramsChangeObj
      // this.paramsChangeObj = {
      //   type: 'reset',
      //   num: num + 1,
      // }
    },
    initSelectOpt(state) {
      let selectList = []
      if (state === 'sectionType') {
        selectList = this.selectList
        this.selectList = selectList.map((item) => {
          if (item) {
            item.curVal = this[`curSelect_${item.state}`]
          }
          return item
        })
      } else if (state === 'svg') {
        selectList = this.svgSelectList
        this.svgSelectList = selectList.map((item) => {
          if (item) {
            item.curVal = this[`curSelect_${item.state}`]
          }
          return item
        })
        console.debug('this.svgSelectList:', this.svgSelectList)
      }
    },
    selectChangeVal(data) {
      console.debug('selectChangeVal:', data)
      if (data.state === 'sectionType') {
        this.curSelect_sectionType = data.val
      } else if (data.state === 'homePlayer') {
        this.curSelect_homePlayer = data.val
      } else if (data.state === 'awayPlayer') {
        this.curSelect_awayPlayer = data.val
      }
      console.debug(
        this.curSelect_sectionType,
        this.curSelect_homePlayer,
        this.curSelect_awayPlayer
      )
      this.getHotSpotData()
    },
    clickPublish(index) {
      // 分享主题
      // 投篮分布俩个展示主题，其实是一个主题分析项
      let themeItem = JSON.parse(JSON.stringify(this.themeList[0]))
      console.debug(
        'themeItem:',
        themeItem,
        this.curSelect_sectionType,
        index,
        this.curSelect_homePlayer,
        this.teamInfors
      )
      themeItem.actJson = {
        period: this.curSelect_sectionType,
        teamId: this.teamInfors[index].teamId,
        dataType:
          index === 0 ? this.curSelect_homePlayer : this.curSelect_awayPlayer,
      }
      console.debug(
        themeItem.actJson.dataType,
        typeof themeItem.actJson.dataType
      )
      let showStyleType = ''
      let dataTypeFormatVal = Number(themeItem.actJson.dataType)
      // NaN(非数字的字符串都是NaN); 首发|替补[1,0]; 运动员都是大于1的字符串数字
      if (dataTypeFormatVal - 0 > 1) {
        showStyleType = 'player'
      } else {
        showStyleType = 'team'
      }

      let analysisItemStyles = []
      themeItem.analysisItemStyles.forEach((styleItem) => {
        if (
          styleItem.styleFilterList &&
          styleItem.styleFilterList.includes(showStyleType)
        ) {
          styleItem.act = false
          analysisItemStyles.push(styleItem)
        }
      })
      if (analysisItemStyles.length > 0 && analysisItemStyles.length === 1) {
        analysisItemStyles[0].act = true
      }
      themeItem.analysisItemStyles = analysisItemStyles
      themeItem.matchId = this.query.mid
      this.clickPublicTheme(themeItem)
    },
    // clickPublicTheme(index) {
    //   // 分享主题
    //   // 投篮分布俩个展示主题，其实是一个主题分析项
    //   let themeItem = JSON.parse(JSON.stringify(this.themeList[0]))
    //   console.debug(
    //     'themeItem:',
    //     themeItem,
    //     this.curSelect_sectionType,
    //     index,
    //     this.curSelect_homePlayer,
    //     this.teamInfors
    //   )
    //   themeItem.actJson = {
    //     period: this.curSelect_sectionType,
    //     teamId: this.teamInfors[index].teamId,
    //     dataType:
    //       index === 0 ? this.curSelect_homePlayer : this.curSelect_awayPlayer,
    //   }
    //   console.debug(
    //     themeItem.actJson.dataType,
    //     typeof themeItem.actJson.dataType
    //   )
    //   let showStyleType = ''
    //   let dataTypeFormatVal = Number(themeItem.actJson.dataType)
    //   // NaN(非数字的字符串都是NaN); 首发|替补[1,0]; 运动员都是大于1的字符串数字
    //   if (dataTypeFormatVal - 0 > 1) {
    //     showStyleType = 'player'
    //   } else {
    //     showStyleType = 'team'
    //   }

    //   let analysisItemStyles = []
    //   themeItem.analysisItemStyles.forEach((styleItem) => {
    //     if (
    //       styleItem.styleFilterList &&
    //       styleItem.styleFilterList.includes(showStyleType)
    //     ) {
    //       styleItem.act = false
    //       analysisItemStyles.push(styleItem)
    //     }
    //   })
    //   if (analysisItemStyles.length > 0 && analysisItemStyles.length === 1) {
    //     analysisItemStyles[0].act = true
    //   }
    //   themeItem.analysisItemStyles = analysisItemStyles
    //   window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
    //     flag: true,
    //     themeItem: themeItem,
    //     mid: this.query.mid
    //       ? this.query.mid
    //       : themeItem.matchId
    //       ? themeItem.matchId
    //       : 0,
    //   })
    // },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    _formatSelectHandler(resDataArr, isRefreshFlag) {
      let selectList = this.selectList
      console.debug('selectList:', selectList)
      // this.curSelect_sectionType = res.data[1][0].value + ''
      // selectList[0].list = res.data[1].map((item) => {
      //   item.value = item.value + ''
      //   return item
      // })

      const sectionTypeSelList = [resDataArr[1]]
      selectList.forEach((svgItem, svgIndex) => {
        svgItem.list = sectionTypeSelList[svgIndex].map((item, itemIndex) => {
          const val = item.value + ''
          item.value = val
          if (isRefreshFlag && this[`curSelect_${svgItem.state}`] === val) {
            svgItem.curVal = val
          } else if (!isRefreshFlag) {
            if (itemIndex == 0) {
              svgItem.curVal = val
              this[`curSelect_${svgItem.state}`] = val
            }
          }
          return item
        })
      })
      this.selectList = selectList

      let svgSelectList = this.svgSelectList
      const orginSvgSelList = [resDataArr[0], resDataArr[2]]
      svgSelectList.forEach((svgItem, svgIndex) => {
        svgItem.list = orginSvgSelList[svgIndex].map((item, itemIndex) => {
          const val = item.value + ''
          item.value = val
          if (isRefreshFlag && this[`curSelect_${svgItem.state}`] === val) {
            svgItem.curVal = val
          } else if (!isRefreshFlag) {
            if (itemIndex == 0) {
              svgItem.curVal = val
              this[`curSelect_${svgItem.state}`] = val
            }
          }
          return item
        })
      })
      this.svgSelectList = svgSelectList
      console.debug('this.svgSelectList:', this.svgSelectList)
      this.initSelectOpt('svg')
    },
    _formatSpotDataHandler(arr) {
      //实际坐标x,y轴最大值 [49, 45.71] = [1, 1] 图表里面的x,y轴最大值
      // 以下是实际坐标对应图表中的各个点的位置
      // [-24.5, -5.56] = [0, 0] 左上角
      // [0,0] = [0.5,0.5] 中间
      // [24.5, 40.16] = [1, 1] 右下角

      const reality_x = 49,
        reality_y = 45.71
      const ceilRateNum_x = 100 / reality_x,
        ceilRateNum_y = 100 / reality_y
      return {
        pointX: Math.round(ceilRateNum_x * (arr[0] + 24.5) * 10) / 1000,
        pointY: Math.round(ceilRateNum_y * (arr[1] + 5.56) * 10) / 1000,
      }
    },
    findAnalysisItemCallback(resData) {
      // 主题数据和主题分析项分开，分析项有数据后展示分享按钮
      let jsonArr = []
      if (resData && resData.length > 0) {
        this.themeList = resData.map((item) => {
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
      } else {
        this.themeList = []
        this.themeItem = null
      }
    },
    async refreshCallback() {
      this.isRefreshFlag = true
      await this.getSelectList()
      await this.getHotSpotData()
    },
    async getSelectList() {
      await https_teamDetail_hotspotsSelectList(
        this.axiosBaseUrl,
        this.$axios,
        {
          sid: this.currSid,
          mid: this.query.mid,
        }
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data) {
              this._formatSelectHandler(res.data, this.isRefreshFlag)
              // this.initSelectOpt('sectionType')
              // this.initSelectOpt('svg')
            } else {
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getHotSpotData() {
      await https_teamDetail_hotspotsData(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
        matchId: this.query.mid,
        homeDataType: this.curSelect_homePlayer,
        period: this.curSelect_sectionType,
        awayDataType: this.curSelect_awayPlayer,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data && res.data.length > 0) {
              // res.data = [{}, {}] 要么对象有值，要么就是空对象
              const teamInfors = []
              const dynamicOptsArr = []
              const keyArr = ['home', 'away']
              keyArr.forEach((key) => {
                if (key === 'home') {
                  teamInfors.push({
                    teamId: this.matchInfor.homeId,
                    teamLogo: this.matchInfor.homeTeamLogo,
                    teamName: this.matchInfor.homeTeam,
                  })
                } else if (key === 'away') {
                  teamInfors.push({
                    teamId: this.matchInfor.awayId,
                    teamLogo: this.matchInfor.awayTeamLogo,
                    teamName: this.matchInfor.awayTeam,
                  })
                }
                dynamicOptsArr.push({
                  webKey: key,
                  webType: '',
                })
              })

              this.dynamicOptsArr = dynamicOptsArr
              this.teamInfors = teamInfors
              this.themeList_data = keyArr.map((key, keyIndex) => {
                return {
                  data: res.data[keyIndex],
                  objectInfo: [teamInfors[keyIndex]],
                  statisticsModels: [],
                }
              })
              console.debug('this.themeList:', this.themeList, teamInfors)
              if (
                this.isRefresh &&
                this.refreshCallbackHandle &&
                !this.setIntervalId
              ) {
                this.refreshCallbackHandle(this.refreshCallback)
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#schedule_hotspots {
  padding-bottom: 2.778vw;
  .teamInfor_main {
    position: relative;
    width: 100%;
    height: 7.636vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    padding: 2.778vw 0 1.388vw;
    .teamItem {
      width: 50%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      &:nth-child(2) {
        flex-direction: row-reverse;
        .teamName {
          text-align: right;
        }
      }
      .teamLogo {
        width: 3.47vw;
        height: 3.47vw;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        width: calc(100% - 3.47vw);
        padding: 0 1.388vw;
        font-size: 1.388vw;
        color: var(--mixtmt_greyColor3);
        text-align: left;
      }
    }
    .section_main {
      position: absolute;
      top: 3.15vw;
      left: 50%;
      z-index: 2;
      width: 12.5vw;
      transform: translateX(-50%);
    }
  }
  .dataArea {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
    .hotItem {
      width: calc(50% - 0.487vw);
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      &:first-child {
        .hotArea {
          padding-left: 0.974vw;
        }
      }
      &:nth-child(2) {
        flex-direction: row-reverse;
        .hotArea {
          padding-right: 0.974vw;
        }
      }
      .svgList_area {
        width: 16.66vw;
        border: 1px solid var(--mixtmt_greyColor7);
        border-radius: 0.694vw;
        .svgArea_header {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.347vw;
          border-bottom: 1px solid var(--mixtmt_greyColor7);
          .svgArea_header_select {
            width: 13.2vw;
          }
          .svgArea_header_public {
            width: calc(100% - 13.2vw);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
          }
        }
        .svgDataRow {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.694vw 0.974vw;
          .svgDataRow_svg {
            width: 50%;
          }
          .svgDataRow_data {
            width: 45%;
            .svgData_annotate_row {
              width: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: space-between;
              align-items: center;
              &:first-child {
                border-bottom: 1px solid var(--mixtmt_greyColor8);
              }
              .svgData_annotate_row_clo1,
              .svgData_annotate_row_clo2 {
                width: 50%;
                font-size: 0.974vw;
                line-height: 2.5vw;
                text-align: center;
              }
              .svgData_annotate_row_clo2 {
                padding-top: 0.3vw;
                font-size: 1.1vw;
                font-family: 'DINCondensed-Bold';
                font-weight: bold;
              }
            }
          }
        }
      }
      .hotArea {
        width: calc(100% - 16.66vw);
        height: auto;
        &.notTip {
          .themeTips {
            display: none;
          }
        }
        .themeTips {
          padding-top: 1.388vw;
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          .themeTipsItem {
            flex: 1;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .themeTipsItem_icon {
              width: 1.388vw;
              height: 1.388vw;
              border-radius: 50%;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            .themeTipsItem_text {
              padding-left: 0.347vw;
              font-size: 0.974vw;
              line-height: 1.388vw;
            }
          }
        }
      }
    }
  }
  .publishBtn {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    width: 3.6vw;
    svg.publishBtn_icon {
      fill: var(--mixtmt_greyColor4);
    }
  }
}
.mixtmt_pc #schedule_hotspots {
  .publishBtn {
    cursor: pointer;
    &:hover {
      svg.publishBtn_icon {
        fill: var(--mixtmt_subColor1_1);
      }
    }
  }
}
</style>
